<script setup>
import ShortMessageServiceForm from '@frontJs/components/forms/projectManagement/sem/ShortMessageServiceForm.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const { tenant, websiteVariants, semShortMessageService } = defineProps({
    tenant: {
        type: Object,
        required: true,
    },
    websiteVariants: {
        type: Array,
        required: true,
    },
    semShortMessageService: {
        type: [Object, null],
        required: false,
        default: null,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title v-if="semShortMessageService">
            Mettre à jour le SMS #{{ semShortMessageService.id }} - SEM -
            Gestion de projet - Datakepler
        </title>

        <title v-else>
            Créer un SMS - SEM - Gestion de projet - Datakepler
        </title>
    </Head>

    <PageTitle v-if="semShortMessageService" :tenant-name="tenant.name">
        Gestion de projet - SEM - Mettre à jour le SMS #{{
            semShortMessageService.id
        }}
    </PageTitle>

    <PageTitle v-else :tenant-name="tenant.name">
        Gestion de projet - SEM - Créer un SMS
    </PageTitle>

    <ShortMessageServiceForm
        :tenant="tenant"
        :website-variants="websiteVariants"
        :sem-short-message-service="semShortMessageService"
    />
</template>
